module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_03-04d27b8919231b55a3bfda2f0b5d3a31.jpg";